module.exports = __webpack_public_path__ + "img/5-2.8fc14d53.png";